export enum LinkDisplayStatus {
  SHOW = "show",
  NO_PERMISSIONS = "noPermissions",
  POSTHOG_FEATURE_FLAGGED = "posthogFeatureFlagged",
  COMPANY_FEATURE_FLAGGED = "companyFeatureFlagged",
  FEATURE_GATED = "featureGated",
}

export const ROUTE_ACCESS_STATUS_MESSAGES: Record<LinkDisplayStatus, string> = {
  [LinkDisplayStatus.SHOW]: "",
  [LinkDisplayStatus.NO_PERMISSIONS]: "You don't have permission to access this feature",
  [LinkDisplayStatus.POSTHOG_FEATURE_FLAGGED]: "This feature is currently disabled",
  [LinkDisplayStatus.COMPANY_FEATURE_FLAGGED]: "This feature is not enabled for your company",
  [LinkDisplayStatus.FEATURE_GATED]: "This feature requires a higher plan",
};
